import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["quote", "picture", "fullName", "jobTitle"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { PICTURE_PROP_TYPES } from "../../constants/prop-types";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Container, Quote, Picture, FullName, JobTitle } from "./testimonial-module.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TestimonialModule = function TestimonialModule(_ref) {
  var _rest$style;
  var quote = _ref.quote,
    picture = _ref.picture,
    fullName = _ref.fullName,
    jobTitle = _ref.jobTitle,
    rest = _objectWithoutProperties(_ref, _excluded);
  var src = picture.src,
    loading = picture.loading,
    decoding = picture.decoding,
    fetchpriority = picture.fetchpriority,
    _picture$role = picture.role,
    role = _picture$role === void 0 ? 'presentation' : _picture$role,
    alt = picture.alt;
  var textColor = rest === null || rest === void 0 ? void 0 : (_rest$style = rest.style) === null || _rest$style === void 0 ? void 0 : _rest$style.color;
  var quoteStyle = {};
  if (textColor) {
    quoteStyle.color = textColor;
  }
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/_jsx(Quote, {
      style: quoteStyle,
      children: quote
    }), /*#__PURE__*/_jsx(Picture, {
      alt: alt,
      role: role,
      src: src,
      loading: loading,
      decoding: decoding,
      fetchpriority: fetchpriority
    }), /*#__PURE__*/_jsx(FullName, {
      children: fullName
    }), /*#__PURE__*/_jsx(JobTitle, {
      children: jobTitle
    })]
  }));
};
TestimonialModule.displayName = 'TestimonialModule';
TestimonialModule.propTypes = {
  quote: PropTypes.string.isRequired,
  picture: PropTypes.shape(PICTURE_PROP_TYPES).isRequired,
  fullName: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(TestimonialModule);